import * as types from 'training/actions/types'

const initialState = {
    selectedTrainingTemplate: null,
    trainingTemplateList: [],
    isLoading: true,
    hasError: false,
    errors: [],
    searchText: '',

    currentTraining: null,
    currentCodes: []
}

export default function training(state = initialState, action) {
    switch (action.type) {

        case types.LOAD_TRAINING_TEMPLATES:
            return {...state, isLoading: true}
        case types.LOAD_TRAINING_TEMPLATES_SUCCESS:
            return {...state, isLoading: false, trainingTemplateList: action.trainingTemplateList}

        case types.SEARCH_TRAINING_TEMPLATES:
            return {...state, searchText: action.searchText}
        case types.SELECT_TRAINING_TEMPLATE:
            return {...state, selectedTrainingTemplate: action.trainingTemplate}
        case types.DESELECT_TRAINING_TEMPLATE:
            return {...state, selectedTrainingTemplate: null}

        case types.CREATE_TRAINING_TEMPLATE:
            return {...state, isLoading: true}
        case types.CREATE_TRAINING_TEMPLATE_SUCCESS:
            return {...state, isLoading: false, selectedTrainingTemplate: action.trainingTemplate}

        case types.UPDATE_TRAINING_TEMPLATE:
            return {...state, selectedTrainingTemplate: action.payload, trainingTemplateList:
            state.trainingTemplateList.map(t => t.id === action.payload.id ? action.payload : t)
            }
        case types.SAVE_TRAINING_TEMPLATE:
        case types.SAVE_TRAINING_TEMPLATE_SUCCESS:
            return {...state, selectedTrainingTemplate: action.trainingTemplate}
        case types.SAVE_TRAINING_TEMPLATE_ERROR:
            return {...state, errors: action.payload}
        case types.DELETE_TRAINING_TEMPLATE:
            return {...state, isLoading: true}
        case types.DELETE_TRAINING_TEMPLATE_SUCCESS:
            return {...state, isLoading: false}

        case types.LOAD_TRAINING_TEMPLATES_ERROR:
        case types.CREATE_TRAINING_TEMPLATE_ERROR:
        case types.UPDATE_TRAINING_TEMPLATE_ERROR:
        case types.DELETE_TRAINING_TEMPLATE_ERROR:
            return {...state, isLoading: false, hasError:true, errors: action.errors}
        default:
            return state
    }
}
